<script>
  import { RootStyle, Spinner, SubscriptionSelection } from '@storytel/design-system-web';
  import { onMount, tick } from 'svelte';
  import { fetchSubscriptionComponentData } from './helpers/api';

  export let firstrow = null,
    secondrow = null,
    countryiso = null,
    language = null,
    env = app.env.isProd ? 'prod' : app.env.isDev ? 'dev' : 'test',
    showdarkbackground = 'true';

  let isMounted = false;
  let fetchComponentData;
  onMount(async () => {
    await tick();
    isMounted = true;

    fetchComponentData = (async () =>
      await fetchSubscriptionComponentData({
        env,
        countryIso: countryiso,
        language,
        firstRow: firstrow,
        secondRow: secondrow,
      }))();
  });
</script>

<svelte:options tag={null} />
<RootStyle>
  {#if isMounted}
    {#await fetchComponentData}
      <div
        class="loading"
        style="display: flex; align-items: center; justify-content: center; height: 1000px;
        background-color: #ffccc2;"
      >
        <Spinner />
      </div>
    {:then data}
      <SubscriptionSelection
        {data}
        isCustomerInactive={data.isCustomerInactive}
        currentActiveSubscription={data.currentActiveSubscription}
        showDarkBackground={showdarkbackground === 'true'}
      />
    {:catch error}
      {console.log(error)}
    {/await}
  {/if}
</RootStyle>
